import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function Partners() {
    const { t } = useTranslation();
    const [partners, setPartners] = useState([]);

    useEffect(() => {
        fetch("https://ligasos-laravel.ligasos.co/api/partners")
            .then((response) => response.json())
            .then((data) => setPartners(data))
            .catch((error) => console.error("Error fetching partners:", error));
    }, []);

    return (
        <div className="bg-gray-100 p-6">
            <div className="max-w-[84rem] f-col flex items-center gap-[30px] mx-auto">
                <p className="text-gray-600 mb-4 text-lg font-medium leading-[1.1]">
                    {t("Partners with Dubai’s leading developers")}
                </p>
                <div className="dir-ltr relative overflow-hidden w-full">
                    <div className="dir-ltr flex animate-marquee">
                        {partners.concat(partners).map((partner, index) => (
                            <div
                                key={`${partner.id}-${index}`}
                                className="flex justify-center items-center mx-[2rem]"
                            >
                                <img
                                    src={`https://ligasos-laravel.ligasos.co/storage/app/public/${partner.image_path}`}
                                    alt={`partner-logo-${partner.id}`}
                                    className="w-auto h-auto max-w-[100px] max-h-[100px]"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}